import { render, staticRenderFns } from "./TwoFactorAuth.vue?vue&type=template&id=5252d2c3&scoped=true"
import script from "./TwoFactorAuth.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuth.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuth.vue?vue&type=style&index=0&id=5252d2c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5252d2c3",
  null
  
)

export default component.exports